const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function tenantFromLeadSearch(search: string): string | null {
  const parameters = new URLSearchParams(search);
  const leadId = parameters.get("lead");
  const tenantId = parameters.get("tenant");
  if (!leadId || !tenantId) return null;
  if (!UUID_PATTERN.test(leadId) || !UUID_PATTERN.test(tenantId)) return null;
  return tenantId;
}

export function safeReturnPath(value: string | null, origin: string): string | null {
  if (!value || value.length > 2_048 || !value.startsWith("/") || value.startsWith("//")) {
    return null;
  }
  const url = new URL(value, origin);
  if (url.origin !== origin) return null;
  return `${url.pathname}${url.search}${url.hash}`;
}

export function tenantFromReturnPath(value: string | null, origin: string): string | null {
  const path = safeReturnPath(value, origin);
  if (!path) return null;
  return tenantFromLeadSearch(new URL(path, origin).search);
}
